import { AssignMobileOfferRequest, MobileOfferAssignment, MobileOfferPage } from '@numeo/types'

type HistoryReader = (userId: string, cursor?: string) => Promise<MobileOfferPage<MobileOfferAssignment>>

/** Read all reachable history pages; assignment errors can happen after insertion. */
export async function findCustomerAssignment(
    readHistory: HistoryReader,
    userId: string,
    matches: (record: MobileOfferAssignment) => boolean
): Promise<MobileOfferAssignment | undefined> {
    let cursor: string | undefined
    const seen = new Set<string>()
    do {
        const page = await readHistory(userId, cursor)
        const record = page.items.find(matches)
        if (record) return record
        if (!page.nextCursor) return undefined
        if (seen.has(page.nextCursor)) throw new Error('Customer history pagination did not advance')
        seen.add(page.nextCursor)
        cursor = page.nextCursor
    } while (cursor)
    return undefined
}

export function matchesCustomerAssignment(record: MobileOfferAssignment, request: AssignMobileOfferRequest): boolean {
    return record.userId === request.userId && record.offerId === request.offerId && record.provider === request.provider
}
